import { render, staticRenderFns } from "./SlotReviewForm.vue?vue&type=template&id=ef99137a&"
import script from "./SlotReviewForm.vue?vue&type=script&lang=js&"
export * from "./SlotReviewForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports